import EmailVerify from "./EmailVerify";

export default EmailVerify;
